/** Space around the nested bill grid. The file actions column adds this width so both actions columns share a left edge. */
export const billPdfPreviewNestedGridInsetPx = 16

export const billPdfPreviewActionsColumnWidth = (canEdit: boolean): number =>
  canEdit ? 132 : 72
